import Storage from '../util/Storage';

const BookingButton = {
    init: () => {

    },

    updateCount: () => {
        const bookingItems = Storage.getItem(Storage.KEY_SERVICES);
        const bookingCta = $('.js-booking-button');

        if (bookingItems && bookingItems.length) {
            $(bookingCta).find('.js-booking-count').text('(' + bookingItems.length + ')')
            $(bookingCta).addClass('red');
        } else {
            $(bookingCta).find('.js-booking-count').text('');
            $(bookingCta).removeClass('red');
        }
    },

    showTooltip: (serviceAdded) => {
        $('.js-booking-tooltip-text').text(serviceAdded.title);
        $('.js-booking-tooltip').fadeIn(200);
        setTimeout(function() {
            $('.js-booking-tooltip').fadeOut(200);
        }, 2000);
    },
}

Object.freeze(BookingButton);

export default BookingButton;


// WEBPACK FOOTER //
// ./scripts/components/BookingButton.js